export const yesAndNoOptions = [
  {
    value: 'Y',
    label: 'Yes'
  },
  {
    value: 'N',
    label: 'No'
  }
];

export const LIMIT_OPTIONS = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 }
];

export const messageFilters = [
  { value: 'web', label: 'Chat messages' },
  { value: 'sms', label: 'Text messages' }
];

export const documentCategories = [
  { value: 'clinical', label: 'Clinical' },
  { value: 'practice_management', label: 'Practice management' },
  { value: 'imaging_result', label: 'Imaging Result' },
  { value: 'laboratory_result', label: 'Laboratory Result' },
  { value: 'insurance_id', label: 'Insurance ID' },
  { value: 'identification_id', label: 'Identification ID' },
  { value: 'intake_document', label: 'Intake Document' },
  { value: 'legal', label: 'Legal' },
  { value: 'medication_prescription', label: 'Medication/Prescription' },
  { value: 'home_health_document', label: 'Home Health Document' },
  { value: 'medical_records_history', label: 'Medical Records History' },
  { value: 'orders', label: 'Orders' },
  { value: 'efax', label: 'eFax' },
  { value: 'Other', label: 'Other' }
];

export const eps = {
  licenseTypes: [
    { value: 'Primary', label: 'Primary' },
    { value: 'Secondary', label: 'Secondary' }
  ]
};

export const timeIncrements = [
  { value: 5, label: '5 minutes' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 25, label: '25 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
  { value: 120, label: '120 minutes' }
];

export const dateFormats = [
  'YYYY-MM-DD',
  'YYYY-DD-MM',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'YYYY/MM/DD',
  'YYYY/DD/MM',
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'YYYY.MM.DD',
  'DD.MM.YYYY',
  'MM.DD.YYYY',
  'YYYY MM DD',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss.SSS',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm:ss.SSS',
  'YYYY-MM-DD HH:mm:ss.SSSZ',
  'DD MMM YYYY',
  'MMM DD YYYY',
  'YYYY MMM DD',
  'YYYY DD MMM',
  'DD MMMM YYYY',
  'MMMM DD YYYY',
  'YYYY MMMM DD',
  'YYYY DD MMMM',
  'MM/DD/YYYY hh:mm:ss A'
];

export const tableNames = {
  ICD10: 'icd10',
  CPT: 'cpt'
};

export const preferredHPFormNameMapping = {
  present_illness: 'Chief complaint',
  notes: 'General Notes',
  medicationHistory: 'Medications'
};

export const soapFormNameMapping = {
  'patient-needs': 'present_illness'
};

export const preferredSOAPFormNameMapping = {
  notes: 'General Notes',
  'patient-needs': 'Patient Needs / Presenting Issues',
  present_illness: 'Patient Needs / Presenting Issues'
};

export const preferredProgressFormNameMapping = {
  notes: 'General Notes'
};

export const intakeFormNameMapping = {
  'patient-needs': 'present_illness',
  'problem-manifestation-definition': 'other_complaints',
  goals: 'goals',
  'time-frames': 'timeFrames',
  'risk-and-co-morbidities': 'riskAndCoMorbidities',
  notes: 'notes'
};

export const preferredIntakeFormNameMapping = {
  'patient-needs': 'Patient Needs / Presenting Issues',
  'problem-manifestation-definition': 'Problem Manifestation / Definition',
  goals: 'goals',
  'time-frames': 'Time Frames',
  'risk-and-co-morbidities': 'Risk and co-Morbidities',
  notes: 'General Notes'
};

export const progressFormNameMapping = {
  'session-quotes-and-contents': 'sessionQuotesAndContents'
};
